import UpsaleCardNarrow from './UpsaleCardNarrow'

export default UpsaleCardNarrow
